import React, { FC } from 'react';
import styled from '@emotion/styled';
import { FormControl, FormLabel, Checkbox, FormControlLabel, Grid, Typography, FormHelperText } from '@mui/material';
import { ClientApplicationOptions } from 'reduxState/store/application/types';
import { CreateApplicationOption } from '../../constants';

export interface CreateAppOptionsProps {
  items: CreateApplicationOption[];
  options: ClientApplicationOptions;
  applicationType: string;
  handleChange: (option: keyof ClientApplicationOptions) => void;
  isDisabled?: boolean;
}

const CreateAppOptions: FC<CreateAppOptionsProps> = ({ items, options, handleChange, isDisabled, applicationType }) => {
  // Check if applicationType includes "Extension"
  // If true, check if browser extension is not checked
  const isExtensionAppType = applicationType && applicationType.includes('Extension');
  const isBrowserExtensionRequired = isExtensionAppType && !options.IsBrowserExtension;

  return (
    <>
      <Styled.FormLabel>Options</Styled.FormLabel>
      {isBrowserExtensionRequired && (
        <FormHelperText className="ml-3 mb-2" error>
          Browser Extension option must be checked for Extension application types
        </FormHelperText>
      )}
      <Styled.GridContainer>
        <Grid container spacing={1} columns={{ xs: 4, sm: 9, md: 8 }}>
          {items.map((item: CreateApplicationOption, index: number) => {
            const isBrowserExtensionOption = item.propertyTarget === 'IsBrowserExtension';
            const hasError = isBrowserExtensionRequired && isBrowserExtensionOption;

            return (
              <Grid item xs={2} sm={3} md={2} key={index}>
                <Styled.FormControlLabel
                  size="small"
                  control={
                    <Checkbox
                      checked={!!options?.[item.propertyTarget]}
                      onChange={() => {
                        handleChange(item.propertyTarget);
                      }}
                      disabled={isDisabled}
                      color={hasError ? 'error' : 'primary'}
                    />
                  }
                  label={<Styled.Typography color={hasError ? 'error' : 'inherit'}>{item.label}</Styled.Typography>}
                />
              </Grid>
            );
          })}
        </Grid>
      </Styled.GridContainer>
    </>
  );
};

export default CreateAppOptions;

const Styled = {
  FormControl: styled((props: any) => <FormControl {...props} />)({
    margin: 1,
  }),
  FormLabel: styled((props: any) => <FormLabel {...props} />)({
    fontFamily: 'inherit',
    fontWeight: 'bold',
    marginBottom: '10px',
  }),
  FormControlLabel: styled((props: any) => <FormControlLabel {...props} />)({
    fontFamily: 'inherit',
  }),
  GridContainer: styled.div({
    marginLeft: '10px',
  }),
  Typography: styled((props: any) => <Typography {...props} />)({
    fontFamily: 'inherit',
    fontSize: '13px',
  }),
};
